import React from 'react';
import { TableRow } from '@mui/material';

import { useAppSelector } from 'store/hooks';
import { RootState } from 'store/types';

import TableHeadCell from './TableHeadCell';

import useStyles from '../styles';

const TableHead: React.FC = () => {
  const classes = useStyles();
  const { columns, tableBodyWidth } = useAppSelector((state: RootState) => state.table);

  return (
    <TableRow
      className={classes.tableRow}
      style={{ maxWidth: tableBodyWidth ? `${tableBodyWidth}px` : 'unset' }}
    >
      {columns.map(c => (
        <TableHeadCell key={c.key} column={c} />
      ))}
    </TableRow>
  );
};

export default TableHead;
